import * as types from "../constants/ActionTypes";

export function clearToolTip() {
    return {
        type: types.CLEAR_TOOLTIP
    };
}

export function setToolTip({x, y, contents}) {
    return {
        type: types.SET_TOOLTIP,
        x,
        y,
        contents
    };
}



// WEBPACK FOOTER //
// ./src/store/actions/ToolTipActions.js